import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "relative mt-1 combobox" }
const _hoisted_2 = { class: "combobox-wrapper" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("line", {
  x1: "18",
  y1: "6",
  x2: "6",
  y2: "18"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("line", {
  x1: "6",
  y1: "6",
  x2: "18",
  y2: "18"
}, null, -1)
const _hoisted_6 = [
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("polyline", { points: "6 9 12 15 18 9" }, null, -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = {
  key: 0,
  class: "relative cursor-default select-none py-2 px-4 text-gray-700"
}

import { OrderStatus as orderstatus } from "@/globals/enums"
import { Helpers as helpers } from "@/helper";
import { Combobox, ComboboxButton, ComboboxInput, ComboboxOption, ComboboxOptions, TransitionRoot } from '@headlessui/vue';
import { ref, computed } from 'vue';
import { useRoute } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'StatusFilter',
  emits: ["submit"],
  setup(__props, { emit }: { emit: ({
    (e: 'submit', value: { value: string | number }): void
}), expose: any, slots: any, attrs: any }) {


const statusQuery = ref('')
const selectedStatus = ref()
let OrderStatus = Object.entries({
    PLACED: orderstatus.PLACED,
    ACCEPTED: orderstatus.ACCEPTED,
    PREPARED: orderstatus.PREPARED,
    ON_THE_WAY: orderstatus.ON_THE_WAY,
})
if (useRoute().name == 'orders') {
    OrderStatus = [
        ...Object.entries({
            PLACED: orderstatus.PLACED,
            ACCEPTED: orderstatus.ACCEPTED,
            PREPARED: orderstatus.PREPARED,
            ON_THE_WAY: orderstatus.ON_THE_WAY,
            DELIVERED: orderstatus.DELIVERED,
            CANCELED: orderstatus.CANCELED,
            DECLINED: orderstatus.DECLINED,
            CANCELED_AUTOMATICALLY: orderstatus.CANCELED_AUTOMATICALLY,
        })
    ]
}
const filteredOrderStatus: any = computed(() => {
    return statusQuery.value === '' ?
        OrderStatus :
        OrderStatus.filter((status: any) => {
            return status[1].toLowerCase()
                .replace(/-|\s+/g, '')
                .includes(statusQuery.value.toLowerCase().replace(/-|\s+/g, ''))
        })
})
const findStatus = (val?: null) => {
    if (val === null) selectedStatus.value = ''
    emit('submit', val === null ? null : selectedStatus.value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Combobox), {
    modelValue: selectedStatus.value,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((selectedStatus).value = $event)),
    nullable: ""
  }, {
    default: _withCtx(({ open }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(ComboboxButton), null, {
            default: _withCtx(() => [
              _createVNode(_unref(ComboboxInput), {
                class: "combobox-input",
                placeholder: "Status",
                onKeyup: _cache[0] || (_cache[0] = _withKeys(($event: any) => (findStatus()), ["enter"])),
                displayValue: (status) =>  status ? _unref(helpers).upperFirst(status).replaceAll('-', ' ') : '',
                onChange: _cache[1] || (_cache[1] = ($event: any) => (statusQuery.value = $event.target.value))
              }, null, 8, ["displayValue"])
            ]),
            _: 1
          }),
          _createVNode(_unref(ComboboxButton), {
            class: "absolute inset-y-0 right-0 flex items-center px-2 text-gray-700",
            as: "button"
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock("svg", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (findStatus(null))),
                xmlns: "http://www.w3.org/2000/svg",
                class: _normalizeClass([selectedStatus.value ? 'block' : 'hidden']),
                width: "18",
                height: "18",
                viewBox: "0 0 24 24",
                "stroke-width": "1.5",
                stroke: "currentColor",
                fill: "none",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, _hoisted_6, 2)),
              (_openBlock(), _createElementBlock("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                class: _normalizeClass(["transform transition duration-300", { 'rotate-180': open }]),
                width: "22",
                height: "22",
                viewBox: "0 0 24 24",
                "stroke-width": "1.5",
                stroke: "currentColor",
                fill: "none",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, _hoisted_9, 2))
            ]),
            _: 2
          }, 1024)
        ]),
        _createVNode(_unref(TransitionRoot), {
          leave: "transition ease-in duration-100",
          leaveFrom: "opacity-100",
          leaveTo: "opacity-0",
          onAfterLeave: _cache[4] || (_cache[4] = ($event: any) => (statusQuery.value = ''))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(ComboboxOptions), { class: "absolute mt-1 max-h-80 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm z-30" }, {
              default: _withCtx(() => [
                (!_unref(filteredOrderStatus).length && statusQuery.value !== '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, " Nothing found. "))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(filteredOrderStatus), ([val], i) => {
                      return (_openBlock(), _createBlock(_unref(ComboboxOption), {
                        key: i,
                        value: _unref(orderstatus)[val],
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (findStatus()))
                      }, {
                        default: _withCtx(({ selected, active }) => [
                          _createElementVNode("li", {
                            class: _normalizeClass(["relative cursor-default select-none py-2 px-4", {
                            'bg-red-50 text-red-600': active || selected,
                            'text-gray-700': !active,
                        }])
                          }, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["block truncate text-sm", { 'font-medium': selected, 'font-normal': !selected }])
                            }, _toDisplayString(_unref(helpers).upperFirst(_unref(orderstatus)[val]).replaceAll('-', ' ')), 3)
                          ], 2)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})